import { create } from 'zustand';
import { devtools } from 'zustand/middleware';

interface CampaignTagModalsState {
	// Tag removal modal
	tagToRemove: string | null;
	campaignID: string | null;

	// Tag input modal
	isTagInputOpen: boolean;
	editingTags: string[];
}

interface CampaignTagModalsActions {
	openRemoveTagModal: (tagID: string, campaignID: string) => void;
	closeRemoveTagModal: () => void;

	openTagInputModal: (campaignID: string, initialTags: string[]) => void;
	closeTagInputModal: () => void;

	setEditingTags: (tags: string[]) => void;
}

export type CampaignTagModalsStore = CampaignTagModalsState & CampaignTagModalsActions;

const initialState: CampaignTagModalsState = {
	tagToRemove: null,
	campaignID: null,
	isTagInputOpen: false,
	editingTags: [],
};

export const useCampaignTagModalsStore = create<CampaignTagModalsStore>()(
	devtools(
		(set) => ({
			...initialState,

			openRemoveTagModal: (tagID, campaignID) =>
				set({
					tagToRemove: tagID,
					campaignID,
				}),

			closeRemoveTagModal: () =>
				set({
					tagToRemove: null,
				}),

			openTagInputModal: (campaignID, initialTags) =>
				set({
					isTagInputOpen: true,
					campaignID,
					editingTags: initialTags,
				}),

			closeTagInputModal: () =>
				set({
					isTagInputOpen: false,
				}),

			setEditingTags: (tags) =>
				set({
					editingTags: tags,
				}),
		}),
		{
			name: 'campaign-tag-modals-store',
		},
	),
);
